<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>用户管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search" :model="formInline" size="small">

			<el-form-item label="用户ID">
				<el-input size="small" placeholder="请输入商品名称" v-model="formInline.uid"></el-input>
			</el-form-item>


			<el-form-item label="用户名">
				<el-input v-model="formInline.userName"></el-input>
			</el-form-item>
			<el-form-item label="用户手机号码">
				<el-input v-model="formInline.phone"></el-input>
			</el-form-item>
			<!--  registerStart registerEnd-->
			<el-form-item label="注册时间">

				<datapicker @click="changgeTime2"
					:timeList="[formInline.registerStart*1000,formInline.registerEnd*1000]"></datapicker>
			</el-form-item>
			<el-form-item label="代理等级">
				<el-select v-model="formInline.agentLevel" placeholder="默认全部" clearable>
					<el-option label="VIP" value="1">
					</el-option>
					<el-option label=" " value="0">
					</el-option>
			
				</el-select>

			</el-form-item>
			<el-form-item label="是否是业务员">
				<el-select v-model="formInline.isBusiness" placeholder="默认全部" clearable>

					<el-option label="是" value="yes">
					</el-option>
					<el-option label="否" value="no">
					</el-option>
				</el-select>

			</el-form-item>
			<!-- <div v-if="scope.row.businessType=='extra'">编外</div> -->
			<!-- <div v-else-if="scope.row.businessType=='normal'">普通</div> -->
			<el-form-item label="业务员状态">
				<el-select v-model="formInline.businessStatus" placeholder="默认全部" clearable>

					<el-option label="正常" value="normal">
					</el-option>
					<el-option label="离职" value="dimission">
					</el-option>
				</el-select>

			</el-form-item>
			
			<el-form-item label="业务员类型">
				<el-select v-model="formInline.businessType" placeholder="默认全部" clearable>
			
					<el-option label="正常" value="normal">
					</el-option>
					<el-option label="编外" value="extra">
					</el-option>
				</el-select>
			
			</el-form-item>

			<el-form-item label="所属门店">
				<el-select v-model="formInline.warehouseId" placeholder="选择门店" clearable>

					<el-option :label="item.warehouseName" :value="item.id" v-for="(item,key) in WarehouseList"
						:key="key">
					</el-option>
				</el-select>

			</el-form-item>

			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>

				<el-button size="small" type="warning" icon="el-icon-delete" @click="clear">清空刷选条件</el-button>

				<el-button size="small" type="warning" @click="exportUser">导出用户列表</el-button>
			</el-form-item>
		</el-form>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;" @selection-change="handleSelectionChange">
			<el-table-column align="center" type="selection" width="60" label="选择">
			</el-table-column>
			<el-table-column type="expand">
				<template slot-scope="scope">
					
					<div style="display: flex;padding: 10px;">
						<div>邀请时间：</div>
						<div>{{web.formatTime(scope.row.invitedTime,'Y-M-D h:m')}}</div>
					</div>
					<div style="display: flex;padding: 10px;">
						<div>数据查看权限：</div>
						<div v-if="scope.row.manageWarehouseIds">
							{{formatmanageWarehouseIds(scope.row.manageWarehouseIds)}}
						</div>
						<div v-else>未设置</div>
					</div>
					<div style="display: flex;padding: 10px;">
						<div>离职时间：</div>
						<div>{{scope.row.dimissionTime?web.formatTime(scope.row.dimissionTime,'Y-M-D'):'在职'}}</div>
					</div>
					<div style="display: flex;padding: 10px;">
						<div>最后访问时间：</div>
						<div>	{{web.formatTime(scope.row.lastTime,'Y-M-D')}} </div>
					</div>
					<div style="display: flex;padding: 10px;">
						<div>会员等级：</div>
						<div>	{{scope.row.agentName?scope.row.agentName:'---'}}</div>
					</div>	
				</template>
			</el-table-column>
			<el-table-column sortable prop="uid" label="用户id" width="100" align="center"></el-table-column>
			<el-table-column prop="username" label="用户名" align="center">
			
			</el-table-column>
			<el-table-column label="门店" align="center">
				<template slot-scope="scope">
					<div v-if="scope.row.warehouseName&&scope.row.isBusiness=='yes'">
						{{scope.row.warehouseName}}
					</div>
					<div v-else-if="scope.row.parentUser&&scope.row.isBusiness!='yes'">
						{{scope.row.parentUser.warehouseName}}
					</div>
					<div v-else>--</div>

				</template>
			</el-table-column>
			
			<el-table-column prop="mobile" label="手机号码" align="center"></el-table-column>
			<el-table-column prop="face" label="用户头像" align="center">
				<template slot-scope="scope">
					<div>

						<el-image style="width: 60px;height: 60px;" :src="scope.row.face"
							:preview-src-list="[scope.row.face]">
						</el-image>
					</div>

				</template>
			</el-table-column>
			<el-table-column sortable prop="createTime" label="注册时间" align="center">
				<template slot-scope="scope">
					{{web.formatTime(scope.row.createTime,'Y-M-D')}}
				</template>
			</el-table-column>
			<el-table-column prop="parentId" label="上级" align="center">
				<template slot-scope="scope">
					<div v-if="scope.row.parentUser ">
						<el-button @click="handleClickName(scope.row.parentUser)" type="text" size="small">
							{{scope.row.parentUser.username}}
						</el-button>
					</div>
					<div v-else>
						无
					</div>
				</template>
			</el-table-column>
		
			<el-table-column prop="agentName" label="用户标签" align="center">
				<template slot-scope="scope">
					<div v-for="item in scope.row.userTags" :key="item.id">
						<el-tag type="success" closable @close="delUserTag(item,scope.row)">{{item.tagName}}</el-tag>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="jxcUserId" label="是否绑定进销存" align="center">
				<template slot-scope="scope">
					<div>
						<div v-if="scope.row.jxcUserId">是({{scope.row.jxcUserId}})</div>
						<div v-else>否</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="isBusiness" label="是否是业务员" align="center">
				<template slot-scope="scope">
					{{scope.row.isBusiness=='yes'?'是':'否'}}
				</template>
			</el-table-column>
			<el-table-column prop="businessType" label="业务员类型" align="center">
				<template slot-scope="scope">
					<div>
						<div v-if="scope.row.businessType=='extra'">编外</div>
						<div v-else-if="scope.row.businessType=='normal'">普通</div>
						<div v-else>-</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="businessTime" label="设为业务员时间" align="center">
				<template slot-scope="scope">
					{{scope.row.isBusiness=='yes'?web.formatTime(scope.row.businessTime,'Y-M-D'):'--'}}
				</template>
			</el-table-column>
			<el-table-column prop="businessStatus" label="状态" align="center">
				<template slot-scope="scope">
					{{scope.row.businessStatus=='normal'?'正常':scope.row.businessStatus=='dimission'?'离职':'--'}}
				</template>
			</el-table-column>
			<el-table-column prop="businessCode" label="业务码" align="center">
				<template slot-scope="scope">
					{{scope.row.businessCode?scope.row.businessCode:'--'}}
				</template>
			</el-table-column>

		</el-table>
		<div style="margin-top: 30px;">
			<el-button type="danger" @click="handleedit1" size="small">添加标签</el-button>

			<el-button type="danger" @click="setUserBusinessShow" size="small">设为业务员</el-button>
			<el-button type="danger" @click="dimissionUserBusiness" size="small">离职业务员</el-button>
			<el-button type="danger" @click="manageWarehouse" size="small">管理门店</el-button>
			<el-button type="danger" @click="bindJxcAdminUser" size="small">绑定进销存管理用户</el-button>
		</div>

		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>

		<!-- 弹框 设代理和设置会员-->
		<el-dialog       :close-on-click-modal="false" title="设置" :visible.sync="dialogVisible" width="30%">
			<el-form>
				<el-form-item label="会员等级" v-if="type=='showVip'">
					<el-select v-model="vipLevel" placeholder="默认全部" clearable @change="handlevipChange">
						<el-option :label="item.vipName" :value="item.level" v-for="(item,key) in vipList" :key="key">
						</el-option>
					</el-select>

				</el-form-item>

				<el-form-item label="代理等级" v-if="type=='showAgent'">
					<el-select v-model="agentLevel" placeholder="默认全部" clearable >
						<el-option :label="item.agentName" :value="item.level" v-for="(item,key) in agentList"
							:key="key"></el-option>
					</el-select>

				</el-form-item>

				<el-form-item label="用户标签" v-if="type=='tag'">
					<el-checkbox-group v-model="checkboxGroup" size="mini" @change="checkboxChange">
						<el-checkbox :label="item.tagId" border v-for="(item,index) in tagList" :key="index">
							{{item.name}}
						</el-checkbox>

					</el-checkbox-group>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="setvip" v-if="type=='showVip'">设置</el-button>
				<el-button type="primary" @click="setagent" v-if="type=='showAgent'">设置</el-button>
				<el-button type="primary" @click="setUserTag" v-if="type=='tag'">设置标签</el-button>
			</span>
		</el-dialog>

		<el-dialog       :close-on-click-modal="false" title="设置" :visible.sync="warehouseVisible" width="30%">
			<el-form>
				<el-form-item label="选择门店">
					<el-select placeholder="默认全部" clearable v-model="warehouseId" @change="handlewarehousechange">
						<el-option :label="item.warehouseName" :value="item.id" v-for="(item,index) in WarehouseList"
							:key="index">
						</el-option>
						
					</el-select>

				</el-form-item>
				<el-form-item label="业务员类型">
					<el-select clearable v-model="businessType">
						<el-option label="普通" value="normal"></el-option>
						<el-option label="编外" value="extra"></el-option>
					</el-select>
				
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="warehouseVisible = false">取 消</el-button>
				<el-button type="primary" @click="setUserBusiness">设为业务员</el-button>

			</span>
		</el-dialog>
		
		<el-dialog       :close-on-click-modal="false" title="设置" :visible.sync="bindJxcAdminUserDialog" width="30%">
			<el-form>
				<el-form-item label="选择管理员用户">
					<el-select placeholder="请选择" clearable v-model="jxcAdminUserId">
						<el-option :label="item.name+item.username" :value="item.uid" v-for="(item,index) in jxcAdminUserList"
							:key="index">
						</el-option>
						
					</el-select>
		
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="bindJxcAdminUserDialog = false">取 消</el-button>
				<el-button type="primary" @click="setUserJxc">设为进销存管理用户</el-button>
		
			</span>
		</el-dialog>
		
		<el-dialog   :close-on-click-modal="false" title="管理门店" :visible.sync="manageWarehouseShow" width="30%">
			<el-form>
				<el-form-item label="查看数据">
					<el-checkbox v-model="alldata">所有数据（包括门店）
					</el-checkbox>
				</el-form-item>
				<el-form-item label="管理门店" style="width: 100%;">
					<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
						:disabled="alldata">全选
					</el-checkbox>
					<div style="margin: 15px 0;"></div>
					<el-checkbox-group v-model="checkedLimit" @change="handleCheckedCitiesChange">
						<el-checkbox v-for="(item,index) in WarehouseList" :label="item.id" :value='item.id'
							:key="index" :disabled="alldata">{{item.warehouseName}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="manageWarehouseShow = false">取 消</el-button>
				<el-button type="primary" @click="manageWarehouseId">确定</el-button>
			</span>
		</el-dialog>


	</div>
</template>

<script>
	import {
		getAllWarehouse,
		userList,
		setUserVip,
		setUserAgent,
		setUserTag,
		delUserTag,
		getUserInfo,
		setUserBusiness,
		stopUserBusiness,
		dimissionUserBusiness,
		setUserManageWarehouse,
		userListExport,
		getJxcAdminUser,
		bindJxcAdminUser
	} from '../../api/basisMG.js'
	// import methodsMixin from '@/utils/methodsMixin'
	// 导出模块
	export default {
		// mixins: [methodsMixin],

		// 模块数据
		data() {
			//数据  
			return {
				bindJxcAdminUserDialog:false,
				jxcAdminUserList:[],
				jxcAdminUserId:'',
				businessType:'normal',
				alldata: false,
				checkAll: false,
				isIndeterminate: true,
				checkedLimit: [],
				manageWarehouseShow: false,
				manageWarehouseIds: '',
				// 门店信息列表
				WarehouseList: [],
				warehouseVisible: false,
				warehouseName: '',
				warehouseId: '',
				vipList: [],
				agentList: [],
				tagList: [],
				loading: false,
				Visible: false,
				time: [],
				checkboxGroup: [],
				type: 'showVip',
				fileList: [],
				listData: [],
				dialogImageUrl: '',
				dialogVisible: false,
				uids: '',
				tagIds: '',
				vipName: '',
				agentName: '',
				vipLevel: '',
				agentLevel: '',
				// 所属分类
				tableData: [],
				value: [],
				editForm: {

				},
				selectEditForm: {},
				usernames: ''
			}
		},


		watch: {},

		methods: {
			bindJxcAdminUser(){
				console.log(this.uids)
				if (this.uids == '') {
					this.$message.error('请选择用户')
					return
				} else if (this.uids.indexOf(',') != -1){
					this.$message.error('只可选择单个用户')
					return
				} else {
					this.bindJxcAdminUserDialog = true
				}
			},
			setUserJxc(){
				let param = {}
				param.jxcAdminUserId = this.jxcAdminUserId
				param.uid = this.uids 
				bindJxcAdminUser(param).then(res=>{
					console.log(res.data)
					if (res.code == '200') {
						this.$message({
							type: 'success',
							message: '设置成功'
						})
						this.getdata()
						this.bindJxcAdminUserDialog = false
						// this.dialogVisible = true
					} else {
						this.$message.error(res.data)
					}
				})
			},
			getJxcAdminUser(){
				getJxcAdminUser().then(res=>{
					console.log(res.data)
					this.jxcAdminUserList = res.data
				})
			},
			formatmanageWarehouseIds(ids) {
				let str = ''
				let dataArr = []
				if (ids != 'all') {
					let arr = ids.split(',')
					console.log(arr)
					let finditem = ''
					arr.forEach(item => {
						finditem = this.WarehouseList.find(obj => {

							return obj.id == item
						})
						dataArr.push(finditem.warehouseName)
						str = str + finditem.warehouseName + ','
					})
				} else {
					str = '全部数据'

				}
				return str

			},
			manageWarehouse() {
				if (this.uids == '') {
					this.$message.error('请选择用户')
					return
				} else {
					if (this.selectEditForm.manageWarehouseIds) {
						if (this.selectEditForm.manageWarehouseIds != 'all') {
							this.checkedLimit = this.selectEditForm.manageWarehouseIds.split(",").map(Number)
						} else {
							this.alldata = true
						}

					}

					console.log('this.checkedLimit', this.checkedLimit)
					this.manageWarehouseShow = true
				}
			},
			handleCheckAllChange(val) {
				console.log('handleCheckAllChange', val)
				let list = []
				if (val) {
					this.WarehouseList.forEach(item => {
						list.push(item.id)
					})
					this.checkedLimit = list
				}else{
					this.checkedLimit = []
				}

				this.manageWarehouseIds = val ? list.join(",") : "";


				this.isIndeterminate = false;
			},
			handleCheckedCitiesChange(value) {
				if (value && value.length) {
					let checkedCount = value.length
					this.checkAll = checkedCount === this.WarehouseList.length
					this.isIndeterminate = checkedCount > 0 && checkedCount < this.WarehouseList.length
					this.manageWarehouseIds = value.join(",")
				} else {
					this.manageWarehouseIds = ""
				}
			},
			//导出用户列表
			exportUser() {
				let param = this.formInline
				userListExport(param)
			},

			// 删除用户标签val
			delUserTag(val, row) {
				console.log(val)

				let msg = '确认删除用户' + row.username + '的' + val.tagName + '标签?'
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delUserTag({
						uids: row.uid,
						tagId: val.tagId
					}).then(res => {
						if (res.code == '200') {
							this.getdata()

						}
					})
				})

			},
			checkboxChange(val) {
				console.log(val)
				this.tagIds = val.join(",")
			},
			handlewarehousechange(val) {
				console.log(val)
				if (val) {
					this.WarehouseList.forEach(item => {
						if (item.id == val) {
							this.warehouseName = item.warehouseName
						}
					})
				} else {
					this.warehouseName = ''
				}
				console.log(this.warehouseName)

			},
			changgeTime2(time) {
				console.log(time)
				if (time.length) {
					this.formInline.registerStart = time[0]
					if (time.length > 1) {
						this.formInline.registerEnd = time[1]
					}
				} else {
					this.formInline.registerStart = ''
					this.formInline.registerEnd = ''
				}

			},
			handleClickName(row) {
				console.log(row)
				// JSON.stringify(row)
				this.$router.push({
					path: '/user/userDetail',
					query: {
						uid: row.uid
					}
				})
				// this.getsingleUserInfo(row)
			},
			// 获取会员详细信息
			getsingleUserInfo(row) {
				getUserInfo(row).then(res => {
					if (res.code == '200') {
						console.log(res.data)

					}
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
				console.log('handleSelectionChange', val)
				let arr = []
				if (val.length == 1) {
					this.selectEditForm = val[0]

				} else {
					this.selectEditForm = {}

				}
				this.checkedLimit = []
				this.alldata = false
				let userNameList = []
				this.multipleSelection.map(item => {
					arr.push(item.uid)
					userNameList.push(item.username)
				})

				this.uids = arr.join(",")
				this.usernames = userNameList.join(",")
			},
			// 获得用户数据
			getdata() {
				let param = this.formInline

				userList(param).then(res => {
					this.saveParams(this.$route.path,param)
					if (res.code == '200') {
						this.listData = res.data.content
						this.pageparm.total = res.data.totalElements
					}
				})

			},
			// 获得用户数据
			getAllWarehouseData() {
				let param = this.formInline
				getAllWarehouse(param).then(res => {
					if (res.code == '200') {
						this.WarehouseList = res.data
						if (this.WarehouseList.length) {
							this.warehouseId = this.WarehouseList[0].id
							this.warehouseName = this.WarehouseList[0].warehouseName
						}
						console.log(this.WarehouseList)

					}
				})

			},
			// 获得所有用户标签


			handleedit(row) {
				this.checkboxGroup = []
				console.log(row)
				this.dialogVisible = true
				this.uids = row.uid
				this.type = "tag"
			},
			handleedit1() {
				if (this.uids == '') {
					this.$message.error('请选择用户')
					return
				} else {
					this.checkboxGroup = []
					this.dialogVisible = true
					this.type = "tag"
				}

			},
			// 设置用户标签
			setUserTag() {
				let params = {
					uids: this.uids,
					tagId: this.tagIds
				}
				setUserTag(params).then(res => {
					if (res.code == '200') {
						this.$message({
							type: 'success',
							message: '设置成功'
						})
						this.getdata()

						this.dialogVisible = false
					}
				})
			},
			// 停用业务员
			stopUserBusiness() {
				let params = {
					uids: this.uids,
					tagId: this.tagIds
				}
				stopUserBusiness(params).then(res => {
					if (res.code == '200') {
						this.$message({
							type: 'success',
							message: '设置成功'
						})
						this.getdata()
						// this.dialogVisible = true
					}
				})
			},
			// 业务员离职
			dimissionUserBusiness() {
				let params = {
					uids: this.uids,
					tagId: this.tagIds
				}
				dimissionUserBusiness(params).then(res => {
					if (res.code == '200') {
						this.$message({
							type: 'success',
							message: '设置成功'
						})
						this.getdata()
						// this.dialogVisible = true
					}
				})
			},
			// 管理门店
			manageWarehouseId() {

				let params = {
					uids: this.uids,
					warehouseIds: this.alldata ? 'all' : this.manageWarehouseIds

				}
				let Warehouse = '无数据查看权限'
				if (this.manageWarehouseIds) {
					Warehouse = this.formatmanageWarehouseIds(this.manageWarehouseIds)
				} 
				let msg = '用户' + this.usernames + '  ' + '权限数据：' + Warehouse + ',是否确认？'

				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then((res1) => {
					console.log(res1)
					setUserManageWarehouse(params).then(res => {
						if (res.code == '200') {
							this.$message({
								type: 'success',
								message: '设置成功'
							})
							this.manageWarehouseShow = false
							this.alldata = false
							this.checkAll = false
							this.isIndeterminate = true
							this.checkedLimit = []

							this.getdata()
							// this.dialogVisible = true
						}
					})
				})

			},
			// 设置业务员
			setUserBusinessShow() {
				this.warehouseVisible = true
			},
			setUserBusiness() {
				let params = {
					uids: this.uids,
					warehouseId: this.warehouseId,
					warehouseName: this.warehouseName,
					businessType:this.businessType
				}

				setUserBusiness(params).then(res => {
					if (res.code == '200') {
						this.$message({
							type: 'success',
							message: '设置成功'
						})
						this.getdata()
						this.warehouseVisible = false
						// this.dialogVisible = true
					} else {
						// this.$message.error(res.data)
					}
				}, error => {
					console.log(error)
					// this.$message.error(error.errormessage)
				})
			},
			// 获得所有会员信息getAllVipLevelInfo
			handlevipChange(val) {
				console.log(val)
				if (val >= 0) {
					this.vipList.forEach(element => {

						if (val == element.level) {
							this.vipName = element.vipName
						}
					});

				} else {
					this.vipName = ''
				}
				this.vipLevel = val
			},
			// 设为vip
			setUserVip() {
				if (this.uids == '') {
					this.$message.error('请选择用户')
					return
				}
				this.dialogVisible = true
				this.type = "showVip"
			},
			setvip() {
				console.log(this.uids)
				let params = {
					uids: this.uids,
					vipLevel: this.vipLevel,
					vipLevelName: this.vipName
				}

				setUserVip(params).then(res => {
					if (res.code == '200') {
						this.$message({
							type: 'success',
							message: '设置成功'
						})
						this.dialogVisible = false
					}

					this.getdata()

				})
			},
			// 设为代理
			setUserAgent() {
				if (this.uids == '') {
					this.$message.error('请选择用户')
					return
				}
				this.type = "showAgent"
				this.dialogVisible = true


			},
			setagent() {
				let params = {
					uids: this.uids,
					agentLevel: this.agentLevel,
					agentLevelName: this.agentName
				}
				setUserAgent(params).then(res => {
					if (res.code == '200') {
						this.$message({
							type: 'success',
							message: '设置成功'
						})
						this.dialogVisible = false
					}
					this.getdata()
				})
			},
			add() {
				this.$router.push({
					path: '/product/productedit'
				})

			},

		},
		// 创建前状态(里面是操作)
		beforeCreate() { },
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			this.getdata()
			this.getAllWarehouseData()
		},
		// 挂载前状态(里面是操作)
		beforeMount() { },
		// 挂载结束状态(里面是操作)
		mounted() { },
		// 更新前状态(里面是操作)
		beforeUpdate() { },
		// 更新完成状态(里面是操作)
		updated() { },
		// 销毁前状态(里面是操作)
		beforeDestroy() { },
		// 销毁完成状态(里面是操作)
		destroyed() { }
	};
</script>

<style scoped>
	.el-form-item {
		width: 30%;
		box-sizing: border-box;
	}

	.just-start {
		display: flex;
		justify-content: flex-start;
	}

	.marginT20 {
		margin-top: 20px;
	}
</style>